import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import AccordionCDS from '@sharedCR/coreDesignSystem/AccordionCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { MersPreviewDrawerTestIds } from '../../MersPreviewDrawer.testIds';

import { NO_PAYLOAD_MESSAGE } from './MersPreviewPayload.constants';
import { accordionStyles, payloadStyles } from './MersPreviewPayload.styles';

// What the real action would send (or would have sent) — request XML or flat-file text — collapsed until asked for. With
// no payload the section opens on a pointer to the message instead. The drawer footer copies the payload.
const MersPreviewPayload = ({ title, payload = null }) => {
  const hasPayload = !_.isNil(payload);

  return (
    <Box data-testid={MersPreviewDrawerTestIds.PAYLOAD_ACCORDION}>
      <AccordionCDS
        arrowSize={IconSize[20]}
        className=""
        customStyles={accordionStyles}
        defaultExpanded={!hasPayload}
        title={title}
        titleVariant="bold14"
      >
        {hasPayload ? (
          <Box component="pre" data-testid={MersPreviewDrawerTestIds.PAYLOAD} sx={payloadStyles}>
            {payload}
          </Box>
        ) : (
          <Typography
            color="text.secondary"
            data-testid={MersPreviewDrawerTestIds.NO_PAYLOAD}
            variant="regular14"
          >
            {NO_PAYLOAD_MESSAGE}
          </Typography>
        )}
      </AccordionCDS>
    </Box>
  );
};

MersPreviewPayload.propTypes = {
  title: PropTypes.string.isRequired,
  payload: PropTypes.string,
};

export default memo(MersPreviewPayload);
